import { Component, computed, inject } from '@angular/core';
import { PackageService } from '@lib/package/package.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';
import { DashboardStatsCardComponent } from '../../../components/dashboard-stats-card/dashboard-stats-card.component';

@Component({
    selector: 'app-count-available-to-request',
    imports: [
        DashboardStatsCardComponent
    ],
    templateUrl: './count-available-to-request.component.html',
    standalone: true,
    styleUrl: './count-available-to-request.component.scss'
})
export class CountAvailableToRequestComponent {
    private readonly _packageService = inject(PackageService);
    protected readonly Number = Number;

    availableToRequestCountResult = toSignal(
        this._packageService.availableToRequestCount().pipe(
            catchError(() => of(null))
        )
    );

    availableToRequest = computed(() => this.availableToRequestCountResult()?.count);

    getPackageCount(): number {
        return this.availableToRequest() && Number(this.availableToRequest()) > 0 ? Number(this.availableToRequest()) : 0;
    }
}
